module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7a564b316d8659a75be31b3bde89ba34.gif";